export interface ChainBalances {
  eth?: { native: string; usdt: string };
  bsc?: { native: string; usdt: string };
  tron?: { native: string; usdt: string };
}

type WalletSession = {
  namespaces: {
    eip155?: { accounts: string[] };
    tron?: { accounts: string[] };
  };
};

type WalletBalanceSource = {
  balances?: ChainBalances;
  getBalances?: () => Promise<ChainBalances | undefined> | ChainBalances | undefined;
};

export type SafeWalletProvider = Record<string, never>;

const emptyBalances: ChainBalances = {
  eth: { native: "0", usdt: "0" },
  bsc: { native: "0", usdt: "0" },
  tron: { native: "0", usdt: "0" },
};

const normalizeBalanceValue = (value: unknown) => {
  if (typeof value === "number" && Number.isFinite(value) && value >= 0) return String(value);
  if (typeof value === "string" && value.trim()) return value.trim();
  return "0";
};

const normalizeChainBalances = (balances?: ChainBalances): ChainBalances => ({
  eth: {
    native: normalizeBalanceValue(balances?.eth?.native),
    usdt: normalizeBalanceValue(balances?.eth?.usdt),
  },
  bsc: {
    native: normalizeBalanceValue(balances?.bsc?.native),
    usdt: normalizeBalanceValue(balances?.bsc?.usdt),
  },
  tron: {
    native: normalizeBalanceValue(balances?.tron?.native),
    usdt: normalizeBalanceValue(balances?.tron?.usdt),
  },
});

const getWindowBalanceSource = () => {
  if (typeof window === "undefined") return undefined;

  return window as unknown as {
    __twproductWalletConnect?: WalletBalanceSource;
    __twproductWalletBalances?: ChainBalances;
  };
};

export const fetchAllBalances = async (): Promise<ChainBalances> => {
  const source = getWindowBalanceSource();
  if (!source) return emptyBalances;

  const bridgeBalances = await source.__twproductWalletConnect?.getBalances?.();
  return normalizeChainBalances(
    bridgeBalances || source.__twproductWalletConnect?.balances || source.__twproductWalletBalances || emptyBalances,
  );
};

export const connectWallet = async (): Promise<{
  provider: SafeWalletProvider;
  session: WalletSession;
}> => ({
  provider: {},
  session: {
    namespaces: {},
  },
});
